const faqItems = [
  {
    id: 1,
    q: '棒棒TV是否需要注册才能观看？',
    a: '不需要。棒棒TV所有内容均支持免费在线观看，无需注册或登录，打开网站即可直接观看你喜欢的电视剧和电影，无任何使用门槛。',
  },
  {
    id: 2,
    q: '视频播放卡顿怎么办？',
    a: '棒棒TV采用全球CDN加速和智能码率自适应技术，系统会根据你的网络状况自动调整画质。如果仍然卡顿，可以尝试切换清晰度或暂停缓冲几秒后再播放。',
  },
  {
    id: 3,
    q: '支持哪些设备观看？',
    a: '棒棒TV支持电脑、平板、手机等多种设备。你可以在浏览器中直接访问，也可以在移动端获得优化的观影体验，随时随地追剧看片。',
  },
  {
    id: 4,
    q: '更新频率是怎样的？',
    a: '棒棒TV每日更新，热播剧集通常在播出后数小时内同步上线。电影大片和综艺节目也会在第一时间更新，确保你不会错过任何精彩内容。',
  },
  {
    id: 5,
    q: '视频画质最高支持多少？',
    a: '棒棒TV最高支持1080P超清画质，部分内容支持4K分辨率。画质选项会根据你的设备和网络条件自动适配，你也可以手动选择适合的清晰度。',
  },
  {
    id: 6,
    q: '如何反馈问题或提交内容建议？',
    a: '你可以通过联系页面的邮箱地址向我们反馈问题或提交建议。我们重视每一位用户的意见，客服团队会在24小时内处理你的反馈。',
  },
];

export default function FAQSection() {
  return (
    <section id="faq" className="w-full py-14 md:py-20 bg-background-50">
      <div className="px-4 md:px-6">
        <div className="mb-8 md:mb-10">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-900">
            常见问题
          </h2>
          <p className="mt-2 text-sm text-foreground-600">
            快速了解棒棒TV
          </p>
        </div>

        <div className="max-w-2xl mx-auto space-y-3">
          {faqItems.map((item) => (
            <details
              key={item.id}
              className="group bg-background-100 rounded-xl overflow-hidden"
            >
              <summary className="flex items-center justify-between px-5 py-4 cursor-pointer list-none">
                <h3 className="text-sm md:text-base font-medium text-foreground-900 pr-4">
                  {item.q}
                </h3>
                <span className="flex-shrink-0 w-6 h-6 flex items-center justify-center rounded-full bg-background-200 group-open:bg-primary-100 transition-colors">
                  <i className="ri-arrow-down-s-line text-foreground-600 group-open:rotate-180 transition-transform"></i>
                </span>
              </summary>
              <div className="px-5 pb-4">
                <p className="text-sm text-foreground-600 leading-relaxed">
                  {item.a}
                </p>
              </div>
            </details>
          ))}
        </div>
      </div>
    </section>
  );
}